import { createReducer, on } from '@ngrx/store';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import * as DocumentActions from './document-type.actions';
import { DocumentType } from '../../services/model';

export interface DocumentTypeState extends EntityState<DocumentType> {
  loading: boolean;
  error: string | null;
}

export const adapter: EntityAdapter<DocumentType> = createEntityAdapter<DocumentType>();

export const initialState: DocumentTypeState = adapter.getInitialState({
  loading: false,
  error: null,
});

export const documentTypeReducer = createReducer(
  initialState,

  on(DocumentActions.fetchDocumentTypes, (state) => ({
    ...state,
    loading: true,
  })),

  on(DocumentActions.loadDocumentTypes, (state, { documentTypes }) =>
    adapter.setAll(documentTypes, { ...state, loading: false })
  ),

  on(DocumentActions.loadDocumentTypeFailed, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
